import request from '@/utils/request'

export function clazzList (query) {
  return request({
    url: '/front/clazz/list/',
    method: 'get',
    params: query
  })
}

export function clazzSimpleInfo (clazzId) {
  return request({
    url: '/front/clazz/' + clazzId + '/simple/info/',
    method: 'get'
  })
}

export function clazzFullInfo (clazzId) {
  return request({
    url: '/front/clazz/' + clazzId + '/full/info/',
    method: 'get'
  })
}

export function checkEnrolRecord (clazzId) {
  return request({
    url: '/front/clazz/' + clazzId + '/enroll/check/',
    method: 'get'
  })
}

export function enrollClazz (clazzId, data) {
  return request({
    url: '/front/clazz/' + clazzId + '/enroll/',
    method: 'post',
    data
  })
}

export function joinClazzList (query) {
  return request({
    url: '/front/join/clazz/list/',
    method: 'get',
    params: query
  })
}

export function clazzUserList (clazzId) {
  return request({
    url: '/front/clazz/' + clazzId + '/user/list/',
    method: 'get'
  })
}

export function clazzWeekUserList (clazzId, week) {
  week = week || 0
  return request({
    url: '/front/clazz/' + clazzId + '/week/' + week + '/user/list/',
    method: 'get'
  })
}

export function clazzMyWeekRank (clazzId, query) {
  return request({
    url: '/front/my/clazz/' + clazzId + '/week/rank/',
    method: 'get',
    params: query
  })
}

export function clazzMyTotalRank (clazzId, query) {
  return request({
    url: '/front/my/clazz/' + clazzId + '/total/rank/',
    method: 'get',
    params: query
  })
}

export function clazzWeekRank (clazzId, query) {
  return request({
    url: '/front/clazz/' + clazzId + '/week/rank/',
    method: 'get',
    params: query
  })
}

export function clazzTotalRank (clazzId, query) {
  return request({
    url: '/front/clazz/' + clazzId + '/total/rank/',
    method: 'get',
    params: query
  })
}

export function clazzDayStat (clazzId, query) {
  return request({
    url: '/front/clazz/' + clazzId + '/day/stat/',
    method: 'get',
    params: query
  })
}

export function checkMyClazzCard (params) {
  return request({
    url: '/front/my_clazz/card/check/',
    method: 'get',
    params
  })
}

export function getMyClazzCard (params) {
  return request({
    url: '/front/my_clazz/card/',
    method: 'get',
    params
  })
}

export function setMyClazzCard (data) {
  return request({
    url: '/front/my_clazz/card/',
    method: 'put',
    data
  })
}

export function getMyClazzCardData (params) {
  return request({
    url: '/front/my_clazz/card/data/',
    method: 'get',
    params
  })
}
